import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {push} from 'react-router-redux';
import {Radio} from 'rmwc';

import * as styles from '../../styles';
import * as actions from './actions';


//Radium(Payment);
export default class Payment extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            method: this.props.is_virtual === false ? this.props.store.getIn(['main', 'payment_method']) : 0,
        }; 
    }

    render() {
        return <div>
            {this.props.active
                ? <div style={{margin: '.5em', userSelect: 'none'}}>
                    <div>
                        {window.gettext('Payment Method')}:
                        <br/>
                        <label
                            key='payment-0-label'
                            htmlFor='payment-0'
                            style={{...styles.field, display: 'flex', alignItems: 'center', height: undefined}}>
                            <Radio
                                key='payment-0'
                                id='payment-0'
                                style={{float: 'right', marginLeft: '.5em'}}
                                checked={this.state.method === 0}
                                onChange={() => this.setState({method: 0})}
                            />
                            <div style={{float: 'right', width: '100%'}}>
                                <i
                                    key='payment-0-info'
                                    className='fa-info-circle fa-lg'
                                    style={{float: 'left', ':hover': {position: 'relative'}}}>
                                    {Radium.getState(this.state, 'payment-0-info', ':hover')
                                        ? <div style={styles.info}>
                                            {window.gettext('Bank gateway description')}
                                        </div> 
                                        : null
                                    }
                                </i>
                                <div style={{fontSize: '1.1em'}}>
                                    {window.gettext('Bank gateway')}
                                </div>
                                <div style={{fontSize: '.9em', color: '#9a9a9a'}}>
                                    {window.gettext('Bank gateway description')}
                                </div>
                            </div>
                        </label>
                        {this.props.is_virtual === false ?

                            <label
                                key='payment-1-label'
                                htmlFor='payment-1'
                                style={{ ...styles.field, display: 'flex', alignItems: 'center', height: undefined }}>
                                <Radio
                                    key='payment-1'
                                    id='payment-1'
                                    style={{ float: 'right', marginLeft: '.5em' }}
                                    checked={this.state.method === 1}
                                    onChange={() => this.setState({ method: 1 })}
                                />
                                <div style={{ float: 'right', width: '100%' }}>
                                    <i
                                        key='payment-1-info'
                                        className='fa-info-circle fa-lg'
                                        style={{ float: 'left', ':hover': { position: 'relative' } }}>
                                        {Radium.getState(this.state, 'payment-1-info', ':hover')
                                            ? <div style={styles.info}>
                                                {window.gettext('Draft description')}
                                            </div>
                                            : null
                                        }
                                    </i>
                                    <div style={{ fontSize: '1.1em' }}>
                                        {window.gettext('Draft')}
                                    </div>
                                    <div style={{ fontSize: '.8em', color: '#9a9a9a' }}>
                                        {window.gettext('Draft description')}
                                    </div>
                                </div>
                            </label>
                            : null
                        }
                        {this.context.user.hasPerm('store.free') && this.props.is_virtual === false
                            ? <label
                                key='payment-2-label'
                                htmlFor='payment-2'
                                style={{
                                    ...styles.field,
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: undefined,
                                }}>
                                <Radio
                                    key='payment-2'
                                    id='payment-2'
                                    style={{float: 'right', marginLeft: '.5em'}}
                                    checked={this.state.method === 2}
                                    onChange={() => this.setState({method: 2})}
                                />
                                <div style={{float: 'right', width: '100%'}}>
                                    <i
                                        key='payment-2-info'
                                        className='fa-info-circle fa-lg'
                                        style={{float: 'left', ':hover': {position: 'relative'}}}>
                                        {Radium.getState(this.state, 'payment-2-info', ':hover')
                                            ? <div style={styles.info}>
                                                {window.gettext('No Payment / Free description')}
                                            </div> 
                                            : null
                                        }
                                    </i>
                                    <div style={{fontSize: '1.1em'}}>
                                        {window.gettext('No Payment / Free')}
                                    </div>
                                    <div style={{fontSize: '.8em', color: '#9a9a9a'}}>
                                        {window.gettext('No Payment / Free description')}
                                    </div>
                                </div>
                            </label>
                            : null
                        }
                        {this.context.user.hasPerm('store.debtor') && this.props.is_virtual === false
                            ? <label
                                key='payment-3-label'
                                htmlFor='payment-3'
                                style={{
                                    ...styles.field,
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: undefined,
                                }}>
                                <Radio
                                    key='payment-3'
                                    id='payment-3'
                                    style={{float: 'right', marginLeft: '.5em'}}
                                    checked={this.state.method === 3}
                                    onChange={() => this.setState({method: 3})}
                                />
                                <div style={{float: 'right', width: '100%'}}>
                                    <i
                                        key='payment-3-info'
                                        className='fa-info-circle fa-lg'
                                        style={{float: 'left', ':hover': {position: 'relative'}}}>
                                        {Radium.getState(this.state, 'payment-3-info', ':hover')
                                            ? <div style={styles.info}>
                                                {window.gettext('Debtor description')}
                                            </div> 
                                            : null
                                        }
                                    </i>
                                    <div style={{fontSize: '1.1em'}}>
                                        {window.gettext('Debtor')}
                                    </div>
                                    <div style={{fontSize: '.9em', color: '#9a9a9a'}}>
                                        {window.gettext('Debtor description')}
                                    </div>
                                </div>
                            </label>
                            : null
                        }
                    </div>
                </div>
                : <div>
                    {window.gettext('Payment Method')}:&nbsp;
                    {this.state.method !== null
                        ? {
                            0: window.gettext('Bank gateway'),
                            1: window.gettext('Draft'),
                            2: window.gettext('No Payment / Free'),
                            3: window.gettext('Debtor'),
                        }[this.props.store.get('method')]
                        : '-'
                    }
                </div>
            }
            {this.props.active
                ? <div>
                    <button
                        style={{
                            ...styles.defaultButton,
                            float: 'left',
                            marginLeft: '.5em',
                        }}
                        onClick={async () => {
                            if (this.state.method === null) {
                                alert(window.gettext('Incomplete data'));
                                return;
                            }
                            this.context.store.dispatch([
                                actions.setPaymentMethod(this.state.method),
                                push({
                                    pathname: '/store/purchase/next/',
                                    query: this.props.location.query,
                                }),
                            ]);
                        }}>
                        {window.gettext('Confirm')}
                    </button>
                </div>
                : null
            }
        </div>;
    }
}
